<template>
	<div id="app">
		<!--out-in-->
		<transition :name="transitionName">
			<router-view class="childView" />
		</transition>
	</div>
</template>

<script>
export default {
  data() {
    return {
      transitionName: 'slide-left'
    }
  },
  watch: {
    $route(to, from) {
      if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left';
      } else {
        this.transitionName = 'slide-right';
      }
    }
  }
}
</script>

<style lang="scss">
	#app {
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}

	.childView {
		position: absolute;
		width: 100%;
		height: 100%;
		overflow: auto;
	}

	.slide-left-enter,
	.slide-right-leave-to {
		transform: translateX(100%);
	}

	.slide-left-enter-to,
	.slide-left-leave,
	.slide-right-enter-to,
	.slide-right-leave {
		transform: translateX(0);
	}

	.slide-left-enter-active,
	.slide-left-leave-active,
	.slide-right-enter-active,
	.slide-right-leave-active {
		transition: .3s;
	}

	.slide-left-leave-to,
	.slide-right-enter {
		transform: translateX(-100%);
	}
</style>
